import React, { Component } from 'react';
import { connect } from 'react-redux'
import { formatDetectionDatetime } from '../../utilities/datetime'
import backButton from '../../assets/backButton.svg'
import screenshotSvg from '../../assets/screenshot.svg'
import htmlSvg from '../../assets/html.svg'
import screenshotSelectedSvg from '../../assets/screenshot_selected.svg'
import htmlSelectedSvg from '../../assets/html_selected.svg'
import UpdatePopover from '../../components/common/popover/updatePopover'
import LoaderWrapper from '../../components/common/LoaderWrapper/LoaderWrapper'
import AceEditor from "react-ace";
// import './SuperFeedDetails.scss';
import { eventTypes } from '../../utilities/eventTypes'

import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/theme-solarized_light"
import { loadEventById, loadScreenshotResized, loadScreenshotMarked, loadHTML } from '../../store/entities/superFeedEvents';
import { getLookupData } from '../../store/entities/lookup'
import { getStatusClass } from '../../utilities/statusCSSClass';
const MARKED_SS_SUFFIX = '_marked';
const RESIZED_SS_SUFFIX = '_resized';
const TYPE_IMG = 'i';
const TYPE_HTML = 'h';
class SuperFeedDetailsView extends Component {
      state = {
        pageContent: '',
        selectedTab: 1,
        defaultModelCode: "PP1",
      }
    
      componentDidMount() {
        this.props.loadEventById(this.props.match.params.id);
        this.props.getLookupData();
      }
    
      handleReturn = () => {
            this.props.history.push(`/super-feed/`);
      }
    
      componentDidUpdate(prevProps) {
         const customers = this.props.customerList || [];
         let {screenshots, markedScreenshots, html} = this.props
         const container = customers.find(c => c.id === this.props.selectedEvent.customerId)?.blobContainer || '';
        if (prevProps.selectedEvent !== this.props.selectedEvent) {
          const selectedEvent = this.props.selectedEvent;
          if (selectedEvent && selectedEvent.eventId) {
            // Load screenshot for the selected event only if not already loaded
            if(!screenshots || !screenshots[selectedEvent.eventId]){
            this.props.loadScreenshotResized(container, [selectedEvent.customerId, selectedEvent.extensionInstallId],
            `${selectedEvent.eventId}${selectedEvent.type === eventTypes.reported_phish? "" : RESIZED_SS_SUFFIX}`,
              TYPE_IMG,
              selectedEvent.eventId
            );
          }

            // Load marked screenshot for the selected event only if not already loaded
            if(!markedScreenshots || !markedScreenshots[selectedEvent.eventId]){
            this.props.loadScreenshotMarked(container, [selectedEvent.customerId, selectedEvent.extensionInstallId],
              `${selectedEvent.eventId}${selectedEvent.type === eventTypes.reported_phish? "" : MARKED_SS_SUFFIX}`,
              TYPE_IMG,
              selectedEvent.eventId
            );
          }

          // Load HTML for the selected event only if not already loaded
            if(!html || !html[selectedEvent.eventId]){
            this.props.loadHTML(container, [selectedEvent.customerId, selectedEvent.extensionInstallId], 
              `${selectedEvent.eventId}`,
              TYPE_HTML,
              selectedEvent.eventId
            );
          }
          }
        }
      }

      fetchCustomerDetails = (customerId) => {
        const customer = this.props.customerList.find(c => c.id === customerId);
        return customer ? customer.displayName : 'NA';
      }

      getModelName =  (modelCode) => { 
        const lookupData = this.props.lookupData || [];
        const selected = modelCode === undefined || modelCode === null ? lookupData[0] : lookupData.find(item => modelCode == item.code);
        const value = selected ? { value: selected.code, label: selected.str_flex_field_1 } : null;
        return value ? value.label : 'NA';
      }
    
      render() {
        const { selectedTab } = this.state
        const { selectedEvent, selectedEventLoading, screenshots, screenshotsLoading, markedScreenshots, markedScreenshotsLoading, html, htmlLoading } = this.props; 
        const screenshotPlaceholder = `${process.env.REACT_APP_EXTERNAL_PAGES_BASE_URL}/placeholders/screenshot.jpeg`;
        return (
          <>
            {(
              <div className="pageContainer superFeedDataCont">
               <LoaderWrapper loading={selectedEventLoading} data={selectedEvent} styles={{ minHeight: '500px' }} placeholderText={"No Data Found"} waitForData={true}>
                <div className="wrapper">
                  <div className="sections actionBar">
                    <div className="pointer" onClick={this.handleReturn}>
                      <img width="25px" src={backButton} alt="" srcSet="" />
                      <span>Return to Super Feed</span>
                    </div>

                    <UpdatePopover
                      {...this.props}
                      role={this.props.tokenRoles}
                      event={selectedEvent}
                      from="superFeedDetails"
                    />
                  </div>
                  
                  <div className="sections details">
                    <div className="tableView">
                      <table id="detailsTable">
                        <tbody>
                        <tr>
                            <td colSpan={2}>
                              <b>Customer Details :</b>
                            </td>
                          </tr>
                        <tr>
                            <td>Organisation</td>
                            <td>
                              {this.fetchCustomerDetails(selectedEvent.customerId)}
                            </td>
                          </tr>

                          <tr>
                            <td colSpan={2}>
                              <b>Threat Details :</b>
                            </td>
                          </tr>
                        <tr>
                            <td>User</td>
                            <td>
                              <b>{selectedEvent.userName ? selectedEvent.userName : 'NA'}</b>
                            </td>
                          </tr>
                          <tr>
                            <td>Brand</td>
                            <td>
                              <b>{selectedEvent.detectedBrands ? selectedEvent.detectedBrands : 'NA'}</b>
                            </td>
                          </tr>
                         <tr>
                            <td>Opened At</td>
                            <td>
                              {formatDetectionDatetime(selectedEvent.detectedOn)}
                            </td>
                          </tr>
                        <tr>
                            <td>AI Model</td>
                            <td>
                              {this.getModelName(selectedEvent?.modelCode)}
                            </td>
                          </tr>
                          <tr>
                            <td>Status</td>
                            <td className={getStatusClass(selectedEvent.status)}>
                              <b>{selectedEvent.status ? selectedEvent.status : "NA"}</b>
                            </td>
                          </tr>
                          <tr>
                            <td>IP</td>
                            <td>{selectedEvent.domainIPAddress || 'NA'}</td>
                          </tr>
                          <tr>
                            <td>Url</td>
                            <td>
                              <span>{selectedEvent.url}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className="divider"></div>
                  <div className="tabView">
                  <div className="tabs pointer">
                    <div
                      className="tab rightLine"
                      onClick={() => this.setState({ selectedTab: 1 })}
                    >
                      <img
                        src={
                          selectedTab === 1
                            ? screenshotSelectedSvg
                            : screenshotSvg
                        }
                        width="25px"
                      />
                      <span style={{ color: selectedTab === 1 && '#2d5fa7' }}>
                        Screenshot
                      </span>
                    </div>
                    <div
                      className="tab rightLine"
                      onClick={() => this.setState({ selectedTab: 2 })}
                    >
                      <img
                        src={selectedTab === 2 ? htmlSelectedSvg : htmlSvg}
                        width="25px"
                      />
                      <span style={{ color: selectedTab === 2 && '#2d5fa7' }}>
                        HTML
                      </span>
                    </div>
                    <div
                      className="tab rightLine"
                      onClick={() => this.setState({ selectedTab: 3 })}
                    >
                      <img
                        src={
                          selectedTab === 3
                            ? screenshotSelectedSvg
                            : screenshotSvg
                        }
                        width="25px"
                      />
                      <span style={{ color: selectedTab === 3 && '#2d5fa7' }}>
                        Vision Analysis
                      </span>
                    </div>
                  </div>
                  <div className="dataView">
                    {selectedTab === 1 && (
                      <div className="imageContainer">
                        <img
                          src={(screenshots[selectedEvent.eventId]) || screenshotPlaceholder}
                          className={'dataImg'}
                        />
                      </div>
                    )}
                    {selectedTab === 2 && (
                      <div className="codeblock">
                        <AceEditor
                          placeholder="This is a placeholder html template"
                          height='100%'
                          width='100%'
                          mode="html"
                          theme="solarized_light"
                          name="html_content"
                          fontSize={16}
                          lineHeight={20}
                          showPrintMargin={true}  
                          showGutter={true}
                          highlightActiveLine={true}
                          value={html[selectedEvent.eventId] || 'HTML not available'}
                          readOnly={true}
                          setOptions={{
                          enableBasicAutocompletion: false,
                          enableLiveAutocompletion: false,
                          enableSnippets: false,
                          showLineNumbers: true,
                          tabSize: 2,
                          }}/>
                      </div>
                    )}
                    {selectedTab === 3 && (
                      <div className="imageContainer">
                        <img
                          src={(markedScreenshots[selectedEvent.eventId]) || screenshotPlaceholder}
                          className={'dataImg'}
                        />
                      </div>
                    )}
                   
                  </div>
                </div>
                  </div>
                </div>
              </LoaderWrapper>
              </div>
            )}
          </>
        )
      }
}

const mapStateToProps = (state) => ({
    selectedEvent: state.entities.superFeedEvents.selectedEvent,
    selectedEventLoading: state.entities.superFeedEvents.selectedEventLoading,
    customerList : state.entities.customers.list,
    lookupData: state.entities.lookup.data,
    screenshots: state.entities.superFeedEvents.screenshots,
    screenshotsLoading: state.entities.superFeedEvents.screenshotsLoading,
    markedScreenshots: state.entities.superFeedEvents.markedScreenshots,
    markedScreenshotsLoading: state.entities.superFeedEvents.markedScreenshotsLoading,
    html: state.entities.superFeedEvents.html,
    htmlLoading: state.entities.superFeedEvents.htmlLoading,
})
const mapDispatchToProps = (dispatch) => ({
    loadEventById: (eventId) => dispatch(loadEventById(eventId)),
    getLookupData: () => dispatch(getLookupData()),
    loadScreenshotResized: (container, filepath, blobName, type, eventId) => dispatch(loadScreenshotResized(container, filepath, blobName, type, eventId)),
    loadScreenshotMarked: (container, filepath, blobName, type, eventId) => dispatch(loadScreenshotMarked(container, filepath, blobName, type, eventId)),
    loadHTML: (container, filepath, blobName, type, eventId) => dispatch(loadHTML(container, filepath, blobName, type, eventId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SuperFeedDetailsView);